// Import action types
import {
  INITIATE_STARTUP_CREATION,
  STARTUP_CREATION_SUCCESS,
  STARTUP_CREATION_FAILURE,
  INITIATE_PUBLISH_NOW,
  PUBLISH_NOW_SUCCESS,
  PUBLISH_NOW_FAILURE,
  INITIATE_PUBLISH_PAGE_LAYOUT,
  INITIATE_PUBLISH_MENU_LAYOUT,
  INITIATE_PUBLISH_LANDING_PAGE_LAYOUT,
  PUBLISH_PAGE_LAYOUT_SUCCESS,
  PUBLISH_PAGE_LAYOUT_FAILURE,
  PUBLISH_MENU_LAYOUT_SUCCESS,
  PUBLISH_MENU_LAYOUT_FAILURE,
} from "./types";

// Action to initiate the creation of a new startup folder in S3
export const initiateStartupCreation = (startupName) => {
  console.log(
    `PMM - SF - action - initiateStartupCreation - startupName is: ${JSON.stringify(
      startupName
    )}`
  );

  return {
    type: INITIATE_STARTUP_CREATION,
    payload: startupName,
  };
};

// Action to handle startup folder creation success
export const startupCreationSuccess = (message) => ({
  type: STARTUP_CREATION_SUCCESS,
  payload: message,
});

// Action to handle startup folder creation failure
export const startupCreationFailure = (error) => ({
  type: STARTUP_CREATION_FAILURE,
  error,
});

// Action to initiate the publishing process
export const initiatePublish = (startupName) => {
  console.log(
    `PMM - SF - action - initiatePublish - startupName is: ${JSON.stringify(
      startupName
    )}`
  );

  return {
    type: INITIATE_PUBLISH_NOW,
    payload: startupName,
  };
};

// Action to handle publish success
export const publishNowSuccess = (message) => ({
  type: PUBLISH_NOW_SUCCESS,
  payload: message,
});

// Action to handle publish failure
export const publishNowFailure = (error) => ({
  type: PUBLISH_NOW_FAILURE,
  error,
});

// Action to initiate publishing the current page layout
export const initiatePublishPageLayout = (payload) => {
  console.log(
    `PMM - SF - action - initiatePublishPageLayout - payload is: ${JSON.stringify(
      payload
    )}`
  );

  return {
    type: INITIATE_PUBLISH_PAGE_LAYOUT,
    payload,
  };
};

// Action to handle page layout publish success
export const publishPageLayoutSuccess = (message) => ({
  type: PUBLISH_PAGE_LAYOUT_SUCCESS,
  payload: message,
});

// Action to handle page layout publish failure
export const publishPageLayoutFailure = (error) => ({
  type: PUBLISH_PAGE_LAYOUT_FAILURE,
  error,
});

// Action to initiate publishing the current menu layout
export const initiatePublishMenuLayout = (payload) => {
  console.log(
    `PMM - SF startupAppActions.js - initiatePublishMenuLayout - payload is: ${JSON.stringify(
      payload
    )}`
  );
  return {
    type: INITIATE_PUBLISH_MENU_LAYOUT,
    payload,
  };
};

export const initiatePublishLandingPageLayout = (payload) => {
  console.log(
    `PMM - SF startupAppActions.js - initiatePublishLandingPageLayout - payload is: ${JSON.stringify(
      payload
    )}`
  );
  return {
    type: INITIATE_PUBLISH_LANDING_PAGE_LAYOUT,
    payload,
  };
};

// Action to handle menu layout publish success
export const publishMenuLayoutSuccess = (message) => {
  console.log(
    `PMM - SF startupAppActions.js - publishMenuLayoutSuccess - message is: ${JSON.stringify(
      message
    )}`
  );
  return {
    type: PUBLISH_MENU_LAYOUT_SUCCESS,
    payload: message,
  };
};

// Action to handle menu layout publish failure
export const publishMenuLayoutFailure = (error) => ({
  type: PUBLISH_MENU_LAYOUT_FAILURE,
  error,
});
